export default {
  language: {
    title: 'Select your language',
    spanish: 'Spanish',
    english: 'English',
    change: 'Change language',
  },
  common: {
    accept: 'Accept',
    cancel: 'Cancel',
    continue: 'Continue',
    finish: 'Finish',
    back: 'Back',
    skip: 'Skip',
    close: 'Close',
    retry: 'Retry',
    yes: 'Yes',
    no: 'No',
    home: 'Home',
    sorry: 'We are sorry',
    poweredBy: 'Powered by:',
    configuration: 'Configuration',
  },
  flow: {
    phoneTitle: 'Share your mobile number so we can confirm your order by SMS!',
    phonePlaceholder: 'Enter your 10-digit mobile number',
    nameTitle: 'Share your name so we can identify your order!',
    namePlaceholder: 'Enter the name used to identify your order',
    selectTypeTitle: 'Where will you eat?',
    dineIn: 'Dine in',
    pickup: 'Take out',
    turnTitle: 'Select your table number',
    turnMessage: 'Select a number from the bar and enter it here, please.',
  },
  menu: {
    favorites: 'Your Favorites',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    optional: 'Optional',
    required: 'required',
    maximum: 'Maximum',
    subtotal: 'Subtotal',
    total: 'Total',
    comments: 'Additional comments',
    addToOrder: 'Add to order',
    verifyModifiers: 'Check your modifiers',
    modifierConfigurationRequired:
      'You must check the required modifier configuration',
    categories: 'Categories',
    banners: 'Banners',
    confirm: 'Confirm',
    requiredSingular: 'required',
    requiredPlural: 'required',
    requiredCount: '{count} {required}',
    selectedRequired: '{selected} / {minimum} {required}',
    maximumCount: 'Maximum {count}',
    requiredMaximum: '{minimum} {required}, Maximum {maximum}',
  },
  session: {
    present: 'Are you still there?',
    expiration:
      'Your session will expire soon. Please select one of the following options',
    exit: 'Exit',
  },
  unlock: {
    adminAccess: 'Administrator access',
    confirmation:
      'You are about to unlock administrator access for this kiosk. You must enter the password to complete this action.\nDo you want to continue?',
    action: 'Unlock',
    passwordPlaceholder: 'Enter the password',
    incorrectPasswordTitle: 'Incorrect password',
    incorrectPasswordMessage: 'The password provided is incorrect',
  },
  errors: {
    connection: 'We are having trouble connecting to the server',
    missingConfiguration: 'Configuration is required',
    cartNotFound: 'Cart not found',
    internal: 'Internal error',
    pinpadConfiguration: 'PIN pad configuration is required',
  },
  checkout: {
    order: 'Your order',
    edit: 'Edit',
    payCash: 'Pay at counter',
    payCard: 'Pay by card',
    tip: 'Tip',
    noTip: 'No tip',
    amount: 'Amount',
    operation: 'Operation',
    authorization: 'Authorization',
    card: 'Card',
    date: 'Date',
    successfulPayment: 'Payment successful',
    successfulRefund: 'Refund successful',
    tipQuestion: 'How much tip would you like to leave?',
    total: 'Total',
    soldOut: 'Sold out',
    addFood: 'Add food',
    emptyOrder: 'There are no items in your order yet',
    noPaymentMethod: 'No payment method is active. Check the configuration',
    branchUnavailable: 'The branch is currently unavailable',
    confirmOrder: 'Is your order correct?',
    productImage: 'Product',
    paymentInstructions:
      'Follow the instructions on the terminal below this screen to complete your payment.',
    paymentPending:
      'Your order will be prepared once you complete the payment.',
    paymentFailed:
      'An error occurred while processing the payment. Your card was not charged',
    paymentRetry: 'Try again or pay for your order at the counter.',
    retryPayment: 'Try again',
    cardDeclined:
      'Your card was not charged. The transaction was declined by your issuing bank. Please try another card.',
    confirmContinue: 'Are you sure you want to continue?',
    refundOrderFailed: 'We could not submit your order.',
    refundInsertCard:
      'To process the refund, insert your card into the terminal.',
    refundInstructions:
      'Follow the instructions on the terminal below this screen to complete the refund.',
    refundCompleted: 'The refund was completed successfully.',
    refundFailed:
      'An error occurred while processing the refund. Ask for assistance at the counter.',
    paymentProcessing:
      'Your order is being processed and you will receive confirmation soon',
    thanksTitle: 'Thank you for visiting {name}!',
    thanksDefault:
      'Thank you for your purchase! You will receive an SMS when your order is ready.',
    scanTicket: 'Scan this QR code to access the receipt on your phone.',
    downloadApp: 'Download our app!',
    appStore: 'Download on the App Store',
    googlePlay: 'Download on Google Play',
    messageSent: 'Message sent successfully',
    success: 'Success',
    unavailableTitle: 'Oops!',
    unavailableMessage: 'One of the products you ordered has just sold out.',
    unavailableAction: 'Try again by replacing or removing the product.',
    soldOutProduct: 'Sold-out product',
    soldOutCart: 'Your cart contains items that have sold out',
    soldOutResolution:
      'Remove or replace the selected item to continue your order.',
    viewCart: 'View cart',
    returnToCart: 'Return to cart',
    cancelOrder: 'Cancel order',
    logo: 'Logo',
    adomicilioLogo: 'Adomicilio logo',
    removeProductMessage:
      'Are you sure you want to remove this product?\n\n This action cannot be undone.',
    cancelOrderMessage:
      'Are you sure you want to cancel your order?\n\n This action cannot be undone.',
    wait: 'Wait!',
    confirmRemove: 'Yes, remove',
    confirmCancel: 'Yes, cancel',
    stayInOrder: 'Stay in my order',
    pickupReference: 'The customer will pick up at the {branch} branch',
  },
  test: {
    printer: 'Printer test',
  },
};
